import { useState } from "react";
import { dayjs } from "tools/timezone";
import { useGetForbush } from "service/forbush";
import Chart from "./Chart";
import Map from "./Map";
import "./forbush.css";
import Timer from "./Timer";

const localTimeZone = "Asia/Bangkok";

const Forbush = () => {
  const [showChart, setShowChart] = useState<boolean>(false);
  const { data, isLoading } = useGetForbush();

  const onClick = () => {
    setShowChart(!showChart);
  };

  document.title = "FORBUSH DECREASE";
  return (
    <div>
      <div className="uppercase font-geometo lg:!text-[50px] !text-[40px] lg:leading-[50px] leading-[40px] w-[300px] left-[20px] top-[20px] z-[10000] text-white fixed">
        Forbush Decrease
        {!isLoading && <div className="block sm:mt-[40px] mt-[100px] text-[50px] text-[#54c5ff] font-semibold whitespace-nowrap">ดัชนี KP: {data?.stations?.[0]?.kp_index}</div>}
      </div>
      <div className="sm:right-[50px] sm:top-[20px] z-[10000] fixed text-white top-[120px] max-sm:left-[20px]">
        <Timer />
      </div>
      <button type="button" onClick={onClick} className={`fixed ${showChart ? "bottom-[0]" : "bottom-[20px]"} left-0 z-[10001] flex items-center h-[32px] text-black bg-white px-3 py-1 rounded-none font-geometo sm:hidden`}>
        {showChart ? <span className="text-[30px] leading-[0] rotate-[-45deg]">‹</span> : "Chart"}
      </button>
      <div className={`fixed bottom-[20px] left-[20px] z-[10000] rounded-[20px] overflow-hidden border-[1px] border-[#999] sm:block ${showChart ? "" : "hidden"}`}>{data?.chart && <Chart data={data.chart} />}</div>
      {data?.stations && <Map data={data.stations} />}
    </div>
  );
};

export default Forbush;
